<div class="user-panel">

  <!-- Interactive Profile Pill Trigger -->
  <div class="up-trigger" (click)="toggleDropdown(); $event.stopPropagation()" [class.up-trigger-active]="dropdownOpen"
    role="button" tabindex="0" (keydown.enter)="toggleDropdown(); $event.stopPropagation()"
    [attr.aria-expanded]="dropdownOpen" title="{{ userDisplayName || 'User Profile' }}">

    <div class="up-avatar-wrapper">
      <img [src]="profileImage || defaultProfileImage" (error)="onImageError($event)" class="up-trigger-img"
        alt="Profile" />
      <span class="up-status-dot"></span>
    </div>

    <div class="up-user-info" *ngIf="userDisplayName || roleName">
      <div class="up-user-top">
        <span class="up-user-name" [title]="userDisplayName">{{ userDisplayName || 'User' }}</span>
      </div>
      <div class="up-user-bottom" *ngIf="roleName">
        <span class="up-user-role" [title]="roleName">{{ roleName }}</span>
      </div>
    </div>

    <i class="dx-icon dx-icon-chevrondown up-chevron" [class.rotated]="dropdownOpen"></i>
  </div>

  <!-- Custom dropdown menu -->
  <div class="up-dropdown" *ngIf="dropdownOpen" (click)="$event.stopPropagation()">

    <!-- User summary header -->
    <div class="up-user-header" *ngIf="userDisplayName || roleName">
      <div class="up-user-header-profile">
        <img [src]="profileImage || defaultProfileImage" (error)="onImageError($event)" class="up-header-avatar"
          alt="Profile" />
        <div class="up-header-details">
          <div class="up-user-name">{{ userDisplayName || 'User' }}</div>
          <div class="up-user-role-pill" *ngIf="roleName">{{ roleName }}</div>
        </div>
      </div>
      <div class="up-user-loc" *ngIf="locationText">
        <i class="dx-icon dx-icon-map"></i>
        <span>{{ locationText }}</span>
      </div>
    </div>

    <div class="up-menu-list">
      <ng-container *ngFor="let item of menuItems">

        <!-- Skip language menu item — rendered separately below -->
        <ng-container *ngIf="!item.isLanguageMenu">

          <!-- Profile row -->
          <div *ngIf="item.isProfile" class="up-row" (click)="handleItemClick(item)" role="button" tabindex="0">
            <div class="up-row-icon-wrap">
              <img [src]="profileImage || defaultProfileImage" (error)="onImageError($event)" class="up-profile-img"
                alt="Profile" />
            </div>
            <span class="up-text">{{ item.text }}</span>
          </div>

          <!-- Disabled row (e.g. Version) -->
          <div *ngIf="!item.isProfile && item.disabled" class="up-row up-row-disabled">
            <div class="up-row-icon-wrap">
              <i *ngIf="item.icon" class="dx-icon dx-icon-{{ item.icon }}"></i>
            </div>
            <span class="up-text">{{ item.text }}</span>
          </div>

          <!-- Regular clickable row -->
          <div *ngIf="!item.isProfile && !item.disabled" class="up-row" (click)="handleItemClick(item)" role="button"
            tabindex="0">
            <div class="up-row-icon-wrap">
              <i *ngIf="item.icon" class="dx-icon dx-icon-{{ item.icon }}"></i>
            </div>
            <span class="up-text">{{ item.text }}</span>
          </div>

        </ng-container>

      </ng-container>
    </div>

    <!-- Language row with inline segmented toggle -->
    <div class="up-lang-wrapper">
      <div class="up-row up-lang-row">
        <div class="up-lang-left">
          <div class="up-row-icon-wrap">
            <i class="dx-icon dx-icon-globe"></i>
          </div>
          <span class="up-text">{{ langService.currentLang === 'mr' ? 'भाषा' : 'Language' }}</span>
        </div>

        <div class="up-lang-toggle" (click)="$event.stopPropagation()">
          <button type="button" class="up-lang-btn" [class.up-lang-active]="langService.currentLang === 'en'"
            (click)="selectLang('en')">
            EN
          </button>
          <button type="button" class="up-lang-btn" [class.up-lang-active]="langService.currentLang === 'mr'"
            (click)="selectLang('mr')">
            मराठी
          </button>
        </div>
      </div>
    </div>

    <!-- Theme row with inline segmented toggle -->
    <div class="up-lang-wrapper up-theme-wrapper" *ngIf="false">
      <div class="up-row up-lang-row">
        <div class="up-lang-left">
          <div class="up-row-icon-wrap">
            <i class="dx-icon dx-icon-palette"></i>
          </div>
          <span class="up-text">{{ langService.currentLang === 'mr' ? 'थीम' : 'Theme' }}</span>
        </div>

        <div class="up-lang-toggle" (click)="$event.stopPropagation()">
          <button type="button" class="up-lang-btn" [class.up-lang-active]="themeService.currentTheme === 'light'"
            (click)="selectTheme('light')" title="Light Theme">
            ☀️ {{ langService.currentLang === 'mr' ? 'लाइट' : 'Light' }}
          </button>
          <button type="button" class="up-lang-btn" [class.up-lang-active]="themeService.currentTheme === 'dark'"
            (click)="selectTheme('dark')" title="Dark Theme">
            🌙 {{ langService.currentLang === 'mr' ? 'डार्क' : 'Dark' }}
          </button>
        </div>
      </div>
    </div>

  </div>

</div>